import React, { useState } from "react";
import { sampleUsers, tabs } from "../../utils/constants/adminControl";
import Tabs from "../../components/reuseable/Tabs";
import UserManagement from "../../components/userManagement/UserManagement";
import UserRegistrations from "../../components/userManagement/UserRegistrations";

export default function Index() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div
      style={{
        borderRadius: 8,
        padding: 32,
        // margin: "84px 40px 100px 40px",
        minHeight: "calc(100vh - 124px)",
        boxSizing: "border-box",
        boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
        display: "block",
      }}
      className="bg-[#bb1ccc]/5"
    >
      <Tabs activeTab={activeTab} setActiveTab={setActiveTab} tabs={tabs} />

      {activeTab === 0 && (
        <>
          <UserManagement sampleUsers={sampleUsers} />
        </>
      )}
      {activeTab === 1 && <UserRegistrations />}
      {/* {activeTab === 2 && <NotificationManagement />} */}

    
    </div>
  );
}
